import React from 'react';
import PropTypes from 'prop-types';
import { getImageSrc } from 'common/utils/utils';
import  { lazy } from 'react';

const NextImagesComponent = lazy(() => import('next/image'));

const Image = ({
   src,
   isNextApp,
   alt,
   usedNextImage = true,
   ...rest
}) => {
   if(isNextApp && usedNextImage){

      return (
         <NextImagesComponent
            src={ src }
            alt={ alt }
            { ...rest }
         />
      )
   }
   return (
      <img
         src={ getImageSrc(src, isNextApp) }
         alt={ alt }
         { ...rest }
      />
   )
}



Image.propTypes = {
   src: PropTypes.string,
   isNextApp: PropTypes.bool,
   usedNextImage: PropTypes.bool,
   alt: PropTypes.string,
};

export default Image;
